'use strict';

require('normalize.css/normalize.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/style/css.js
// module id = 225
// module chunks = 121